<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="author"><a id="page_3"></a><strong><span class="underline">LARRY BOND</span></strong></p>
<h1 class="book-title">COLD CHOICES</h1>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td style="width:45%" valign="top"><p class="right-para"><img alt="Image" src="images/publisher.jpg"/></p></td>
<td style="width:55%" valign="top"><p class="para"><strong><span class="smallcaps">A TOM DOHERTY ASSOCIATES BOOK<br/>NEW YORK</span></strong></p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?450d3080